import { ErrorBoundary } from 'components/Errors/ErrorBoundary';
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './index.css';

interface Props {
  title?: string | JSX.Element;
  subTitle?: JSX.Element;
  onClose: () => void;
  childComponent?: JSX.Element;
  customFooter?: JSX.Element;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  style?: React.CSSProperties;
  className?: string;
}

const ModalDialog = ({
  title,
  subTitle,
  customFooter,
  childComponent,
  size = 'lg',
  onClose,
  style,
  className,
}: Props) => {
  if (childComponent === undefined) return <></>;
  return (
    <Modal
      size={size}
      className={className}
      style={{ width: '100%', ...style }}
      isOpen={childComponent !== undefined}
      // fade={false}
      centered={true}
      zIndex={9999}
    >
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>
        <ErrorBoundary>
          {subTitle}
          {childComponent}
        </ErrorBoundary>
      </ModalBody>
      <ModalFooter className="text-right">
        {customFooter ? (
          customFooter
        ) : (
          <Button className="float-right" color="primary" onClick={onClose}>
            Close
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ModalDialog;
